import { NgModule } from '@angular/core';
import { SwipesumFooterComponent } from './swipesum-footer.component';
    
@NgModule({
    declarations: [SwipesumFooterComponent],
    exports: [SwipesumFooterComponent]
})
export class AppFooterModule {
}